/**
 * Adds a KML layer to the Google Map instance with the specified URL.
 * @param {object} options - The options for adding the KML layer.
 * @param {string} options.kmlUrl - The URL of the KML layer to add.
 * @param {object} options.map - The Google Map instance to add the KML layer to.
 * @param {object} options.maps - The Google Maps API object.
 * @returns {object} The Google Maps KmlLayer instance.
 */
export const addKMLLayer = ({ kmlUrl, map, maps, }) => {
    return new maps.KmlLayer({
        url: kmlUrl,
        map,
        preserveViewport: true,
    });
};
